import { render, staticRenderFns } from "./addclientticket.vue?vue&type=template&id=e5a4de38&"
import script from "./addclientticket.vue?vue&type=script&lang=js&"
export * from "./addclientticket.vue?vue&type=script&lang=js&"
import style0 from "./addclientticket.vue?vue&type=style&index=0&id=e5a4de38&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports